import classNames from 'classnames';
import { forwardRef } from 'react';
const optionContainerSpacelessCss = "oqr3k6t";
const optionContainerCss = "o1221x9x";
export const OptionContainer = forwardRef((props, ref) => {
  const {
    spaceless,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(optionContainerCss, {
    [optionContainerSpacelessCss]: spaceless
  }, props.className)} />;
});

require("./option_container.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./option_container.js");